import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Bag = createSvgIcon(
  () => (
    <path d="M11 5.5V4.5C11 2.3125 9.1875 0.5 7 0.5C4.78125 0.5 3 2.3125 3 4.5V5.5H0V14C0 15.4062 1.09375 16.5 2.5 16.5H11.5C12.875 16.5 14 15.4062 14 14V5.5H11ZM5 4.5C5 3.40625 5.875 2.5 7 2.5C8.09375 2.5 9 3.40625 9 4.5V5.5H5V4.5ZM10 8.25C9.5625 8.25 9.25 7.9375 9.25 7.5C9.25 7.09375 9.5625 6.75 10 6.75C10.4062 6.75 10.75 7.09375 10.75 7.5C10.75 7.9375 10.4062 8.25 10 8.25ZM4 8.25C3.5625 8.25 3.25 7.9375 3.25 7.5C3.25 7.09375 3.5625 6.75 4 6.75C4.40625 6.75 4.75 7.09375 4.75 7.5C4.75 7.9375 4.40625 8.25 4 8.25Z" />
  ),
  '0 0 14 17'
);
